import React, {useState, useContext, useEffect} from "react";
import { UserContext } from '../../context/UserContext'
import { v4 as uuidv4 } from 'uuid';

const Wysiwyg = ({ callback, currentAnswer }) => {
  const {
    getAnswers,
  } = useContext(UserContext);
  const answer = currentAnswer ? currentAnswer.answer : null;
  const findAnswer = getAnswers().find(i => i.answer === answer);
  const foundAnswer = findAnswer ? findAnswer.answer : '';

  const handleClick = (e) => {
    const answer = e.target.value;
    callback(answer);
  }
  // const [ state, setState] = useState(null);
  
  return (
    <>
      <div key={uuidv4()}>
        <textarea
          key={uuidv4()}
          id={ 'textarea' }
          name={ 'text' }
          className="rounded-tl-3xl rounded-br-3xl border-gray-400 border w-full px-4 py-4"
          placeholder=""
          rows="5"
          cols="33"
          defaultValue={answer}
          onBlur={handleClick}
        />
      </div>
    </>
  );
};

export default Wysiwyg;
